import React, { useEffect, useRef, useState } from "react";
import VerticalSpace from "../../VerticalSpace";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faX } from "@fortawesome/free-solid-svg-icons";
import Label from "../../Common/Label";
import editIcon from "../../../assets/editIcon.svg";
import deleteIcon from "../../../assets/deleteIcon.svg";
import flashcardBg from "../../../assets/flashcardBg.png"
import { useNavigate, useLocation, useParams } from "react-router-dom";
import RadioButton from "../../Common/RadioButton";
import ArrowIcon from "../../../assets/ArrowIcon.svg";
import CustomDropdown from "../../Common/CustomDropdown";
import HorizontalSpace from "../../HorizontalSpace";
import ParticlesType from "../../Common/ParticleType";
import RowContainer from "../../Common/RowContainer";
import RightSideArrow from "../../../assets/RightSideArrow.svg";
import Container from "../../Common/Container";
import ColumnContainer from "../../Common/ColumnContainer";
import { toast } from "react-toastify";
import dragAndDropIcon from "../../../assets/Images/drag&drop.svg";
import CloseIcon from "../../../assets/Images/closeIconBretzel.svg";
import {
  baseURL,
  deleteRequest,
  getRequest,
  postRequest,
} from "../../../api/apiClient";
import Toast from "../../Common/Toast";
import "../../../stylesheets/theme.css";
import DeleteConfirmation from "../../Common/DeleteConfirmation";
import Loader from "../../../utils/Loading";
import gsap from "gsap";
import "../../../stylesheets/common.css";
import DeleteLoader from "../../../utils/deleteLoader";
import BlockTextComponent from "../../FlashCardContentPreview/BlockTextComponent";
import ExampleComponent from "../../FlashCardContentPreview/ExampleComponent";
import FlashCardImageComponent from "../../FlashCardContentPreview/FlashCardImageComponent";
import ConjugationComponent from "../../FlashCardContentPreview/ConjugationComponent";
import ParticalList from "../../FlashCardContentPreview/ParticalList";
import ConjugationList from "../../FlashCardContentPreview/ConjugationListComponent";
import GrammarGroupComponent from "../../FlashCardContentPreview/GrammarGroupComponent";
import GrammarSingleComponent from "../../FlashCardContentPreview/GrammarSingleComponent";
import { identity } from "lodash";
import Switch from "../../Common/Switch";

interface FlashCardContent {
  id: number;
  name: string;
  order: number;
}

function HeartIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.75"
        y="0.75"
        width="34.5"
        height="34.5"
        rx="17.25"
        fill="none"
        stroke="grey"
        strokeWidth="0.5"
      />

      <g transform="translate(18 18) scale(0.8) translate(-18 -18)">
        <path
          d="M30 15.1649C30 17.0551 29.2874 18.8706 28.015 20.2136C25.0859 23.3059 22.2449 26.5305 19.2064 29.5108C18.5099 30.184 17.405 30.1594 16.7386 29.4558L7.98451 20.2136C5.3385 17.4199 5.3385 12.91 7.98451 10.1164C10.6565 7.29533 15.0095 7.29533 17.6815 10.1164L17.9998 10.4523L18.3178 10.1166C19.5989 8.76328 21.3437 8 23.1664 8C24.989 8 26.7337 8.7632 28.015 10.1164C29.2876 11.4594 30 13.2748 30 15.1649Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>

  )
}

function FlashcardIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.75"
        y="0.75"
        width="34.5"
        height="34.5"
        rx="17.25"
        fill="none"
        stroke="grey"
        strokeWidth="0.5"
      />
      <g transform="translate(18 18) scale(0.8) translate(-18 -18)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.41335 12.6394C6.22488 10.0333 8.26105 8 11.1203 8C14.4687 8 16.4959 9.83717 17.631 11.9614C17.7712 12.2239 17.8984 12.4913 18.0137 12.7611C18.1191 12.4999 18.2347 12.2409 18.3614 11.9867C19.4024 9.89733 21.2721 8 24.3686 8C27.4501 8 29.6379 9.92759 30.5346 12.5692C31.4206 15.1795 31.0676 18.4829 29.2592 21.5125C27.8686 23.8423 26.2077 25.3394 24.5676 26.2997C25.3614 27.0727 26.0996 27.7427 26.6702 28.2577C27.0801 28.6277 27.1125 29.2601 26.7424 29.6701C26.3724 30.08 25.74 30.1124 25.3301 29.7423C24.6401 29.1195 23.6717 28.2411 22.6418 27.2084C20.7344 27.9105 19.0265 28 18.0324 28C17.0005 28 15.257 27.8749 13.3127 27.1101C12.8561 27.5701 12.4153 28.0034 12.0152 28.3967C11.5003 28.9028 11.0529 29.3426 10.7262 29.6876C10.3465 30.0886 9.71356 30.1059 9.31254 29.7261C8.91152 29.3464 8.89426 28.7134 9.274 28.3124C9.69003 27.8731 10.1897 27.3829 10.7375 26.8456C10.9581 26.6293 11.1864 26.4054 11.4201 26.174C9.82661 25.2103 8.2088 23.7471 6.81735 21.5319C4.94399 18.5496 4.601 15.2482 5.41335 12.6394ZM14.8324 25.525C16.1552 25.9301 17.3053 26 18.0324 26C18.7429 26 19.8492 25.9511 21.1175 25.6007C20.8569 25.3099 20.5991 25.0124 20.3475 24.7099C19.4756 23.6618 18.6581 22.5301 18.0548 21.3824C18.0392 21.3528 18.0237 21.3231 18.0084 21.2933C17.9928 21.3221 17.9771 21.3508 17.9612 21.3795C17.3335 22.5152 16.4872 23.6316 15.5973 24.6659C15.3489 24.9546 15.0925 25.2417 14.8324 25.525ZM17.0324 17.8125C17.0324 18.56 16.751 19.4345 16.2108 20.4121C15.6753 21.381 14.925 22.3808 14.0812 23.3615C13.6821 23.8254 13.2748 24.2716 12.8698 24.6991C11.3819 23.8868 9.83505 22.576 8.51094 20.4681C6.92822 17.9484 6.69521 15.2498 7.32291 13.2341C7.95142 11.2157 9.37134 10 11.1203 10C13.5656 10 14.9944 11.271 15.867 12.904C16.7684 14.5908 17.0324 16.6161 17.0324 17.8125ZM19.0324 17.8125C19.0324 18.5719 19.305 19.4626 19.825 20.4517C20.3406 21.4323 21.065 22.4451 21.885 23.4309C22.2813 23.9073 22.6952 24.3718 23.112 24.8177C24.6403 24.0214 26.2246 22.6943 27.5419 20.4875C29.091 17.8921 29.314 15.1956 28.6407 13.2121C27.9781 11.2599 26.4712 10 24.3686 10C22.2809 10 20.9825 11.2108 20.1515 12.8787C19.3039 14.5797 19.0324 16.6188 19.0324 17.8125Z" fill="#FF9E00" />
      </g>
    </svg>

  )
}

function FlashcardColor({ color }: { color: string }) {
  return (
    <svg viewBox="0 0 420 14" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" className="position-absolute start-0 top-0" style={{ width: '100%', height: '14px' }}>
      <path d="M97.8 0H108.8H311.2H322.2H405C408.1 0 411.1 1.11 413.2 3.08L417.5 7.12C419.4 8.97 420 11.44 420 14H0C0 11.44 0.6 8.97 2.5 7.12L6.8 3.08C8.9 1.11 11.9 0 15 0H97.8Z" fill={color} />
    </svg>
  )
}
const FlashCardContent = () => {
  const { id } = useParams();
  const [addFlashContnet, setNewFlashCard] = useState(false);
  const [flashCardName, setFlashCardName] = useState("");
  const [flashcontent, setFlashContent] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [flashcardcontent, setFlashCardContent] = useState<FlashCardContent[]>(
    []
  );
  const [bretzel, setBretzel] = useState<FlashCardContent[]>([]);
  const [flashCardGroups, setFlashCardGroups] = useState([]);
  const [bretzelGroups, setBretzelGroups] = useState([]);
  const [latestUpdatesComponentId, setLatestUpdatesComponentId] = useState();
  const [bretzelId, setBretzelId] = useState("");
  const [selectedOption, setSelectedOption] = useState("bretzel");
  const [flashcardContentError, setFlashCardContentError] = useState("");
  const [dynamicItems, setDynamicItems] = useState<string[]>([]);
  const [particlesBgColor, setParticlesBgColor] = useState("#7542E4");
  const [showParticlesColorPicker, setShowParticlesColorPicker] =
    useState(false);
  const [isBretzelVisible, setBretzelVisible] = useState(true);
  const [deleteDialogMessage, setDeleteDialogMessage] = useState("");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [onConfirmDelete, setOnConfirmDelete] = useState<() => void>(() => { });
  const [flashCardContentToDelete, setFlashCardContentToDelete] = useState<
    number | null
  >(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bretzelLoading, setBretzelLoading] = useState(false);
  const [isMemorize, setIsMemorize] = useState(false);

  const [draggedItemIndex, setDraggedItemIndex] = useState<number | null>(null);
  const touchStartY = useRef<number | null>(null);
  const currentTouchIndex = useRef<number | null>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const { flashCardId } = location.state || {};
  const fetchFlashcardContent = async () => {
    try {
      setIsLoading(true);
      const response = await getRequest(
        `${baseURL}/lesson/get-flashcard-content-components/${id}`
      );

      if (response?.data.data) {
        const filteredContent = response?.data.data.flashcardContentComponent
          .filter((item: FlashCardContent) => item.name !== "Bretzel")
          .sort(
            (a: FlashCardContent, b: FlashCardContent) => a.order - b.order
          );
        setFlashCardName(response?.data.data.name);
        setParticlesBgColor(response?.data.data.color || "#7542E4");
        setLatestUpdatesComponentId(
          response?.data.data.latestUpdatesComponentId
        );
        setFlashCardContent(filteredContent);
        const bretzel = response?.data.data.flashcardContentComponent.filter(
          (item: FlashCardContent) => item.name == "Bretzel"
        );
        setBretzel(bretzel);

        const flashcardGroups = response?.data.data.flashcardGroups || [];

        setFlashCardGroups(flashcardGroups);
        setIsMemorize(flashcardGroups[0]?.isMemorize)
        if (flashcardGroups[0]?.bretzel) {
          setBretzelId(flashcardGroups[0]?.bretzel);
          fetchBretzel(flashcardGroups[0]?.bretzel);
        }

        const itemNames = filteredContent.map(
          (item: FlashCardContent) => item.name
        );
        setDynamicItems(itemNames);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching sub-themes:", error);
    }
  };

  const fetchBretzel = async (bretzelId?: string) => {
    try {
      setBretzelLoading(true);
      const response: any = await getRequest(
        `${baseURL}/lesson/get-bretzel/${bretzelId}`
      );
      if (response?.data.success) {
        const bretzelArray: any = [response?.data?.data];
        setBretzelGroups(bretzelArray || []);
        setBretzelLoading(false);
      }
      setBretzelLoading(false);
    } catch (error) {
      setBretzelLoading(false);
    }
  };

  useEffect(() => {
    fetchFlashcardContent();
  }, [id]);

  const dropdownItems: string[] = [
    "Select Item",
    "Block text",
    "Example",
    "Conjugation",
    "Conjugation List",
    "Grammar group",
    "Particles List",
    "add image / svg",
  ];

  const handleSelect = (item: string) => {
    setFlashContent(item);
    setSelectedItem(item);
  };

  const handleNewFlaseContent = () => {
    setNewFlashCard(true);
  };

  const handleOptionChange = (option: string) => {
    setSelectedOption(option);
  };

  const getContentType = (selectedItem: string): string => {
    switch (selectedItem) {
      case "Block text":
        return "block_text";
      case "Example":
        return "example";
      case "Conjugation":
        return "conjugation";
      case "Conjugation List":
        return "conjugation_list";
      case "Grammar group":
        return "grammar_group";
      case "Particles List":
        return "particle_list";
      case "add image / svg":
        return "add_image_svg";

      default:
        return "";
    }
  };

  const handleDragStart = (index: number) => {
    setDraggedItemIndex(index);
  };

  const handleDragOver = (
    index: number,
    event: React.DragEvent<HTMLDivElement>
  ) => {
    event.preventDefault();
    if (draggedItemIndex !== null && draggedItemIndex !== index) {
      const newFlashcardContent = [...flashcardcontent];
      const draggedItem = newFlashcardContent[draggedItemIndex];
      newFlashcardContent.splice(draggedItemIndex, 1);
      newFlashcardContent.splice(index, 0, draggedItem);
      setFlashCardContent(newFlashcardContent);
      const itemNames = newFlashcardContent.map(
        (item: FlashCardContent) => item.name
      );
      setDynamicItems(itemNames);
      setDraggedItemIndex(index);
    }
  };

  const handleDrop = async () => {
    setDraggedItemIndex(null);

    const updateOrder = flashcardcontent.map((item, index) => ({
      id: item.id,
      order: index + 1,
    }));

    const response = await postRequest(
      `${baseURL}/flashcard-content-component/change-order`,
      updateOrder
    );
    if (response?.data.data) {
      const filteredContent = response?.data.data.filter(
        (item: FlashCardContent) => item.name !== "Bretzel"
      );
      setFlashCardContent(filteredContent);
      const itemNames = filteredContent.map(
        (item: FlashCardContent) => item.name
      );
      setDynamicItems(itemNames);
    }
  };

  const handleDragEnd = () => {
    setDraggedItemIndex(null);
  };

  const handleTouchStart = (
    index: number,
    event: React.TouchEvent<HTMLDivElement>
  ) => {
    event.preventDefault();
    setDraggedItemIndex(index);
    currentTouchIndex.current = index;
    touchStartY.current = event.touches[0].clientY;
  };

  const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (draggedItemIndex !== null && touchStartY.current !== null) {
      const currentY = event.touches[0].clientY;
      const movedDistance = currentY - touchStartY.current;
      const sensitivityThreshold = 1;
      if (Math.abs(movedDistance) > sensitivityThreshold) {
        const newIndex =
          movedDistance > 0
            ? currentTouchIndex.current! + 1
            : currentTouchIndex.current! - 1;
        if (newIndex >= 0 && newIndex < flashcardcontent.length) {
          const newFlashcardContent = [...flashcardcontent];
          const draggedItem = newFlashcardContent[draggedItemIndex];
          newFlashcardContent.splice(draggedItemIndex, 1);
          newFlashcardContent.splice(newIndex, 0, draggedItem);
          setFlashCardContent(newFlashcardContent);
          const itemNames = newFlashcardContent.map(
            (item: FlashCardContent) => item.name
          );
          setDynamicItems(itemNames);
          setDraggedItemIndex(newIndex);
          currentTouchIndex.current = newIndex;
          touchStartY.current = currentY;
        }
      }
    }
  };

  const handleTouchEnd = async () => {
    setDraggedItemIndex(null);
    touchStartY.current = null;
    currentTouchIndex.current = null;
    await handleDrop();
  };

  const handleSaveFlashCard = async () => {
    const contentComponentType = getContentType(selectedItem);

    const activeFlashcardId = flashCardId || id;

    try {
      const nextOrder = flashcardcontent.length + 1;

      const reqData = {
        flashCardId: activeFlashcardId,
        contentComponentType: contentComponentType,
        name: flashcontent,
        order: nextOrder,
      };
      setIsLoading(true);
      const response = await postRequest(
        `${baseURL}/lesson/create-flashcard-content-component`,
        reqData
      );

      if (response?.data) {
        const newflashcardContent: FlashCardContent = {
          id: response?.data.data.id,
          name: response?.data.data.name,
          order: response?.data.data.order,
        };

        setDynamicItems([...dynamicItems, selectedItem]);
        setFlashCardContent([...flashcardcontent, newflashcardContent]);
      }
      setIsLoading(false);
      setFlashContent("");
      setNewFlashCard(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error creating flashcard content:", error);
    }
  };

  const handleConfirmDeleteFlashCardContent = async (id: number) => {
    try {
      setLoading(true);
      const response = await deleteRequest(
        `${baseURL}/lesson/delete-flashcard-content-components/${id}`
      );
      setLoading(false);
      const updatedflashcard = flashcardcontent.filter(
        (flashcardContent) => flashcardContent.id !== id
      );

      const createDynamicName = updatedflashcard.map(({ name }) => {
        return name;
      });

      setFlashCardContent(updatedflashcard);

      const updatedFlashCardGroups: any = flashCardGroups.map((group: any) => {
        if (group.flashCardId) {
          // Assuming you want to update the first flashcard's group
          return {
            ...group,
            components: group.components.filter(
              (component: any) => component.id !== id
            ),
          };
        }
        return group;
      });

      setFlashCardGroups(updatedFlashCardGroups);

      // const updatedDynamicItems = dynamicItems.filter(
      //   (item) => item !== flashcardcontent.find((fc) => fc.id === id)?.name
      // );
      setDynamicItems(createDynamicName);

      setShowDeleteDialog(false);
      setFlashCardContentToDelete(null);
      Toast(response?.data.statusMessage, "success");
    } catch (error) {
      setLoading(false);
      console.error("Error deleting flashcard:", error);
      setShowDeleteDialog(false);
    }
  };

  const handleDeleteFlaseCardContent = (id: number, name: string) => {
    setFlashCardContentToDelete(id);
    setDeleteDialogMessage(`Are you sure you want to delete this "${name}"?`);
    setOnConfirmDelete(() => () => handleConfirmDeleteFlashCardContent(id));
    setShowDeleteDialog(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteDialog(false);
    setFlashCardContentToDelete(null);
  };

  const handleEditBretzel = async () => {
    let bretzelContent = bretzel.find((content) => content.name === "Bretzel");

    if (!bretzelContent) {
      const reqData = {
        flashCardId: flashCardId || id,
        contentComponentType: "bretzel",
        name: "Bretzel",
      };

      try {
        const response = await postRequest(
          `${baseURL}/lesson/create-flashcard-content-component`,
          reqData
        );

        bretzelContent = {
          id: response?.data.data.id,
          name: response?.data.data.name,
          order: response?.data.data.order,
        };
      } catch (error) {
        console.error("Error creating Bretzel content:", error);
        return;
      }
    }

    navigate("/lessons/theme/subthemes/flashcard/content/bretzel", {
      state: { flashcardContentId: bretzelContent.id },
    });
  };

  const handleEditFlashContent = async (id: number, name: string) => {
    let routePath = "/lessons/theme/subthemes/flashcard/content/";

    switch (name) {
      case "Block text":
        routePath += "blocktext";
        break;
      case "Example":
        routePath += "example";
        break;
      case "Conjugation":
        routePath += "conjugation";
        break;
      case "Conjugation List":
        routePath += "conjugation-list";
        break;
      case "Grammar group":
        routePath += "grammar-group";
        break;
      case "Particles List":
        routePath += "particles-list";
        break;
      case "add image / svg":
        routePath += "add-image-svg";
        break;
      case "Bretzel":
        routePath += "bretzel";
        break;
      default:
        break;
    }

    navigate(routePath, {
      state: { flashcardContentId: id },
    });
  };

  const handleColorPicker = async () => {
    setIsLoading(true);
    const resData = {
      flashcardId: flashCardId || id,
      color: particlesBgColor,
      isMemorize
    };
    const response = await postRequest(
      `${baseURL}/flashcard/add-flashcard-color`,
      resData
    );
    setIsLoading(false);
    Toast(response?.data.statusMessage, "success");
  };

  const handleBackClick = async () => {
    const activeFlashcardId = flashCardId || id;
    try {
      const response = await getRequest(
        `${baseURL}/lesson/get-fetch-flashcards/${activeFlashcardId}`
      );
      const subthemeId = response?.data.data[0].subthemeId;
      navigate(`/lessons/theme/subthemes/${subthemeId}`);
    } catch (error) {
      console.error("Error fetching themeId:", error);
    }
  };

  const handlePublishClick = () => {
    handleColorPicker()
    navigate("/lessons");
  };

  const toggleVisibility = () => {
    setBretzelVisible(!isBretzelVisible);
  };

  useEffect(() => {
    let timeLine = gsap.timeline();
    timeLine.from(".row-container", {
      opacity: 0,
      y: -40,
      duration: 0.3,
      ease: "power2.out",
    });

    timeLine.from(".user-data", {
      opacity: 0,
      y: 40,
      duration: 0.5,
      ease: "power2.out",
      stagger: 0.2,
    });

    timeLine.from(".left-container", {
      opacity: 0,
      x: -40,
      duration: 0.3,
      ease: "power2.out",
      stagger: 0.2,
    });

    timeLine.from(".right-container", {
      opacity: 0,
      x: 40,
      duration: 0.5,
      ease: "power2.out",
      stagger: 0.2,
    });
  }, [isLoading]);

  return (
    <div className="container-fluid">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="p-3 main-page">
            <div
              className="d-flex  align-items-center go-back"
              onClick={handleBackClick}
              style={{ width: "fit-content" }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="me-2"
                style={{
                  backgroundColor: "#D9D9D9",
                  padding: "7px",
                  borderRadius: "8px",
                  color: "#000",
                  cursor: "pointer",
                }}
              />
              <label
                style={{
                  color: "#FF9E00",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Back
              </label>
            </div>
            <h4
              className="row-container"
              style={{
                textAlign: "center",
                margin: "auto",
                color: "#7542E4",
                fontWeight: "bold",
              }}
            >
              Flashcard Content
            </h4>
            <VerticalSpace height={30} />
            <div className="row p-3 d-flex main-flashcard justify-content-between">
              <div className="col preview-content left-container">
                <div
                  className="container d-flex justify-content-center"
                  style={{ maxWidth: "666px" }}
                >
                  <div
                    className="container p-3"
                    style={{
                      backgroundColor: "rgb(220 220 220 / 66%)",
                      borderRadius: "30px",
                    }}
                  >
                    <div className="col-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <Label fontSize="20px" fontWeight={700}>
                          Preview
                        </Label>

                        <RowContainer
                          alignItem="center"
                          justifyContent="flex-end"
                        >
                          {/*  */}
                          <RowContainer
                            bgColor="#FFFFFF"
                            padding="10px 10px"
                            borderRadius="10px"
                            border="1px solid #D9D9D9"
                            alignItem="center"
                            onClick={() => setShowParticlesColorPicker(true)}
                            cursor="pointer"
                            gap="15px"
                            width="min-content"
                            // className="user"
                            justifyContent="space-between"
                          >
                            <input
                              type="color"
                              className="form-control form-control-color border-1 p-0"
                              style={{
                                width: "45px",
                                height: "30px",
                                border: "1px solid #D9D9D9",
                                borderRadius: "10px"
                              }}
                              id="myColor"
                              value={particlesBgColor}
                              onChange={(e) =>
                                setParticlesBgColor(e.target.value)
                              }
                            />
                          </RowContainer>
                          {/* <button
                            type="button"
                            className="btn btn-outline-secondary me-2 text-center user"
                            style={{
                              color: "#100F15",
                              background: "none",
                              border: "1px solid #100F15",
                              borderRadius: "10px",
                              padding: "10px 25px",
                              fontSize: "14px",
                              width: "auto",
                            }}
                            onClick={() => handleColorPicker()}
                          >
                            Add color
                          </button> */}
                        </RowContainer>
                      </div>
                      <VerticalSpace height={9} />

                      <Container
                        bgColor="#52525F"
                        border="1px solid #D9D9D9"
                        borderRadius="10px"
                        padding="27px 94px"
                        className="preview-container"
                      >
                        <Container
                          className="position-relative"
                          style={{
                            backgroundImage: `url(${flashcardBg})`,
                            backgroundSize: "100% 100%",
                            height: "500px",
                            borderRadius: "18px 18px 0 0",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <RowContainer
                            // bgColor="#FFFFFF"
                            borderRadius="40px 40px 0px 0px"
                            justifyContent="space-between"
                            padding="25px 18px 8px 16px"
                            alignItem="center"
                          // bgColor={particlesBgColor}
                          >
                            <FlashcardColor color={particlesBgColor} />
                            <HeartIcon />
                            <Label
                              fontSize="15px"
                              color="#000000"
                              fontWeight={700}
                              style={{ textAlign: "center", flex: 1 }}
                            >
                              {flashCardName}
                            </Label>
                            {!bretzel[0]?.id && (
                              <div style={{ width: "24px" }}></div>
                            )}
                            {bretzel[0]?.id && (
                              <span
                                onClick={toggleVisibility}
                                style={{ cursor: "pointer" }}
                              >
                                <FlashcardIcon />
                              </span>
                            )}
                          </RowContainer>

                          <ColumnContainer
                            padding={
                              isBretzelVisible ? "24px" : "50px 0px 0px 0px"
                            }
                            // backgroundColor="#FFFFFF"
                            // borderRadius={
                            //   bretzelLoading
                            //     ? "0px 0px 0px 0px"
                            //     : "0px 0px 18px 18px"
                            // }
                            maxHeight="400px"
                            overflow="auto"
                            style={{
                              // zIndex: 2,
                              scrollbarWidth: "none",
                              msOverflowStyle: "none",
                            }}
                            className="column-container position-relative"
                          >
                            {isBretzelVisible ? (
                              flashCardGroups.length === 0 ? (
                                <>
                                  <RowContainer
                                    alignItem="center"
                                    justifyContent="center"
                                  >
                                    <Label color="#e5dfdf" fontSize="16px">
                                      No Flashcards Available
                                    </Label>
                                  </RowContainer>
                                </>
                              ) : (
                                <>
                                  {flashCardGroups.map(
                                    (group: any, groupIndex) => (
                                      <RowContainer
                                        key={groupIndex}
                                        flexDirection="column"
                                        gap="20px"
                                      >
                                        {group?.components?.map(
                                          (
                                            component: any,
                                            compIndex: number
                                          ) => {
                                            if (
                                              component.contentComponentType ===
                                              "example" &&
                                              component?.data?.size ===
                                              "Half" &&
                                              compIndex > 0 &&
                                              group.components[compIndex - 1]
                                                ?.contentComponentType ===
                                              "example" &&
                                              group.components[compIndex - 1]
                                                ?.data?.size === "Half"
                                            ) {
                                              return null;
                                            }
                                            if (
                                              component.contentComponentType ===
                                              "example" &&
                                              component?.data
                                            ) {
                                              return (
                                                <ExampleComponent
                                                  key={component.id}
                                                  flashCardComponentData={
                                                    component?.data
                                                  }
                                                  currentFlashcard={group}
                                                  currentFlashCardComponentIndex={
                                                    compIndex
                                                  }
                                                  isBretzel={false}
                                                  isHalf={
                                                    component?.data?.size !==
                                                    "Full"
                                                  }
                                                  onClick={(id) => {
                                                    if (id) {
                                                      handleEditFlashContent(
                                                        id,
                                                        "Example"
                                                      );
                                                    }
                                                  }}
                                                />
                                              );
                                            }
                                            return (
                                              <RowContainer
                                                key={component.id}
                                                gap="10px"
                                              // justifyContent="center"
                                              >
                                                {component.contentComponentType ===
                                                  "block_text" &&
                                                  component?.data && (
                                                    <BlockTextComponent
                                                      id={component?.data?.id}
                                                      description={
                                                        component?.data
                                                          ?.description
                                                      }
                                                      lightTheme={
                                                        component?.data
                                                          ?.lightTheme
                                                      }
                                                      isBretzel={false}
                                                      flashCardContentComponentId={
                                                        component?.data
                                                          ?.flashCardContentComponentId
                                                      }
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "Block text"
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {component.contentComponentType ===
                                                  "particle_list" &&
                                                  component?.data && (
                                                    <ParticalList
                                                      data={component?.data}
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "Particles List"
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {component.contentComponentType ===
                                                  "conjugation" &&
                                                  component?.data &&
                                                  component?.data != null && (
                                                    <ConjugationComponent
                                                      data={component?.data}
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "Conjugation"
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {component.contentComponentType ===
                                                  "conjugation_list" &&
                                                  component?.data && (
                                                    <ConjugationList
                                                      data={component?.data}
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "Conjugation List"
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {component.contentComponentType ===
                                                  "add_image_svg" &&
                                                  component?.data && (
                                                    <FlashCardImageComponent
                                                      id={component?.data?.id}
                                                      flashCardContentComponentId={
                                                        component?.data
                                                          ?.flashCardContentComponentId
                                                      }
                                                      flashimage={
                                                        component?.data
                                                          ?.flashimage
                                                      }
                                                      order={
                                                        component?.data?.order
                                                      }
                                                      grammarGroupId={
                                                        component?.data
                                                          ?.grammarGroupId
                                                      }
                                                      britzelId={
                                                        component?.data
                                                          ?.britzelId
                                                      }
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "add image / svg"
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {component.contentComponentType ===
                                                  "grammar_group" &&
                                                  component?.data && (
                                                    <GrammarGroupComponent
                                                      data={component}
                                                      onClick={() =>
                                                        handleEditFlashContent(
                                                          component?.id,
                                                          "Grammar group"
                                                        )
                                                      }
                                                    />
                                                  )}
                                              </RowContainer>
                                            );
                                          }
                                        )}
                                      </RowContainer>
                                    )
                                  )}
                                </>
                              )
                            ) : (
                              <ColumnContainer
                                borderRadius="40px 40px 0px 0px"
                                padding="16px"
                                width="100%"
                                backgroundColor="#FFFFFF"
                              >
                                <RowContainer flexDirection="column">
                                  <RowContainer
                                    alignItem="center"
                                    justifyContent="flex-end"
                                  >
                                    <img
                                      src={CloseIcon}
                                      className="img-fluid user-scale"
                                      style={{
                                        height: "24px",
                                        cursor: "pointer",
                                      }}
                                      alt="Close Icon"
                                      onClick={toggleVisibility} // Proper click handler
                                    />
                                  </RowContainer>
                                  {bretzelLoading ? (
                                    <RowContainer
                                      alignItem="center"
                                      justifyContent="center"
                                      padding="30px"
                                    >
                                      <Loader />
                                    </RowContainer>
                                  ) : (
                                    <>
                                      {bretzelGroups &&
                                        bretzelGroups.length === 0 ? (
                                        <>
                                          <RowContainer
                                            alignItem="center"
                                            justifyContent="center"
                                          >
                                            <Label
                                              color="#7542E4"
                                              fontSize="16px"
                                            >
                                              No Bretzelgroup available
                                            </Label>
                                          </RowContainer>
                                        </>
                                      ) : (
                                        <>
                                          {bretzelGroups?.map(
                                            (group: any, groupIndex) => (
                                              <RowContainer
                                                key={groupIndex}
                                                flexDirection="column"
                                                gap="20px"
                                              >
                                                {group.components.length ===
                                                  0 ? (
                                                  <>
                                                    <RowContainer
                                                      alignItem="center"
                                                      justifyContent="center"
                                                    >
                                                      <Label
                                                        color="#7542E4"
                                                        fontSize="16px"
                                                      >
                                                        No BretzelGroup
                                                        Available
                                                      </Label>
                                                    </RowContainer>
                                                  </>
                                                ) : (
                                                  <>
                                                    {group?.components?.map(
                                                      (
                                                        component: any,
                                                        compIndex: number
                                                      ) => {
                                                        if (
                                                          component.contentComponentType ===
                                                          "example" &&
                                                          component?.data
                                                            ?.size === "Half" &&
                                                          compIndex > 0 &&
                                                          group.components[
                                                            compIndex - 1
                                                          ]
                                                            ?.contentComponentType ===
                                                          "example" &&
                                                          group.components[
                                                            compIndex - 1
                                                          ]?.data?.size ===
                                                          "Half"
                                                        ) {
                                                          return null;
                                                        }
                                                        if (
                                                          component.contentComponentType ===
                                                          "example" &&
                                                          component?.data
                                                        ) {
                                                          return (
                                                            <ExampleComponent
                                                              key={component.id}
                                                              flashCardComponentData={
                                                                component?.data
                                                              }
                                                              isBretzel={true}
                                                              currentFlashcard={
                                                                group
                                                              }
                                                              currentFlashCardComponentIndex={
                                                                compIndex
                                                              }
                                                              isHalf={
                                                                component?.data
                                                                  ?.size !==
                                                                "Full"
                                                              }
                                                              onClick={(id) => {
                                                                if (id) {
                                                                  handleEditFlashContent(
                                                                    id,
                                                                    "Bretzel"
                                                                  );
                                                                }
                                                              }}
                                                            />
                                                          );
                                                        }
                                                        return (
                                                          <RowContainer
                                                            key={compIndex}
                                                            gap="10px"
                                                            justifyContent="center"
                                                          >
                                                            {component.contentComponentType ===
                                                              "block_text" &&
                                                              component?.data && (
                                                                <BlockTextComponent
                                                                  id={
                                                                    component
                                                                      ?.data?.id
                                                                  }
                                                                  description={
                                                                    component
                                                                      ?.data
                                                                      ?.description
                                                                  }
                                                                  lightTheme={
                                                                    component
                                                                      ?.data
                                                                      ?.lightTheme
                                                                  }
                                                                  flashCardContentComponentId={
                                                                    component
                                                                      ?.data
                                                                      ?.flashCardContentComponentId
                                                                  }
                                                                  isBretzel={
                                                                    true
                                                                  }
                                                                  onClick={() =>
                                                                    handleEditFlashContent(
                                                                      component?.flashCardContentComponentId,
                                                                      "Bretzel"
                                                                    )
                                                                  }
                                                                />
                                                              )}
                                                            {component.contentComponentType ===
                                                              "conjugation" &&
                                                              component?.data && (
                                                                <ConjugationComponent
                                                                  data={
                                                                    component?.data
                                                                  }
                                                                  onClick={() =>
                                                                    handleEditFlashContent(
                                                                      component?.flashCardContentComponentId,
                                                                      "Bretzel"
                                                                    )
                                                                  }
                                                                />
                                                              )}
                                                            {component.contentComponentType ===
                                                              "grammar_single" &&
                                                              component?.data && (
                                                                <GrammarSingleComponent
                                                                  data={
                                                                    component?.data
                                                                  }
                                                                  onClick={() =>
                                                                    handleEditFlashContent(
                                                                      component?.flashCardContentComponentId,
                                                                      "Bretzel"
                                                                    )
                                                                  }
                                                                  isBretzel={
                                                                    true
                                                                  }
                                                                  lightTheme={
                                                                    component
                                                                      ?.data
                                                                      ?.lightTheme
                                                                  }
                                                                />
                                                              )}
                                                            {component.contentComponentType ===
                                                              "flash_image" &&
                                                              component?.data && (
                                                                <FlashCardImageComponent
                                                                  id={
                                                                    component
                                                                      ?.data?.id
                                                                  }
                                                                  flashCardContentComponentId={
                                                                    component
                                                                      ?.data
                                                                      ?.flashCardContentComponentId
                                                                  }
                                                                  flashimage={
                                                                    component
                                                                      ?.data
                                                                      ?.flashimage
                                                                  }
                                                                  order={
                                                                    component
                                                                      ?.data
                                                                      ?.order
                                                                  }
                                                                  grammarGroupId={
                                                                    component
                                                                      ?.data
                                                                      ?.grammarGroupId
                                                                  }
                                                                  britzelId={
                                                                    component
                                                                      ?.data
                                                                      ?.britzelId
                                                                  }
                                                                  height="120px"
                                                                  width="120px"
                                                                  onClick={() =>
                                                                    handleEditFlashContent(
                                                                      component?.flashCardContentComponentId,
                                                                      "Bretzel"
                                                                    )
                                                                  }
                                                                />
                                                              )}
                                                          </RowContainer>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                )}
                                              </RowContainer>
                                            )
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </RowContainer>
                              </ColumnContainer>
                            )}
                          </ColumnContainer>
                          {/* <ColumnContainer
                            backgroundColor="white"
                            className="position-absolute translate-middle-x"
                            style={{
                              width: '100%', height: '100px', bottom: '-15%', zIndex: 1,
                              left: "50%",
                              // clipPath: "polygon(0% 0%, 100% 0%, 100% 65.75%, 96.02% 81.71%, 79.57% 81.71%, 75% 100%, 21.03% 100%, 17.18% 81.71%, 5.85% 81.71%, 0% 65.75%)",
                              clipPath: "polygon(0% 0%, 100% 0%, 100% 65.75%, 96.02% 81.71%, 87.5% 82.88%, 82.5% 100%, 17.05% 100%, 13.93% 81.71%, 4.33% 81.56%, 0% 65.75%)"

                            }}
                          >
                          </ColumnContainer> */}

                        </Container>
                      </Container>
                    </div>
                  </div>
                </div>
              </div>
              <HorizontalSpace width={2} />

              <div className="col type-contnet right-container">
                <div
                  className="container d-flex justify-content-center"
                  style={{ maxWidth: "766px" }}
                >
                  <div
                    className="container p-4"
                    style={{
                      backgroundColor: "rgb(220 220 220 / 66%)",
                      borderRadius: "30px",
                    }}
                  >
                    <div className="col-12">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <Label fontSize="20px" fontWeight={700}>
                          Content components
                        </Label>

                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                          <Label fontSize="16px" fontWeight={700}>
                            Memorize pre-created content
                          </Label>
                          <Switch
                            isOn={isMemorize}
                            onToggle={() => setIsMemorize((prev) => !prev)}
                          />
                        </div>
                      </div>

                      <div>
                        {flashcardcontent.length === 0 ? (
                          <div className="p-5 d-flex justify-content-center align-items-center ">
                            <label
                              htmlFor="theme"
                              className="form-label"
                              style={{ fontWeight: "bold", color: "#7542E4" }}
                            >
                              There are no flashcard content yet in this
                              flashcard.
                            </label>
                          </div>
                        ) : (
                          flashcardcontent
                            .filter(
                              (flashcontent) => flashcontent.name !== "Bretzel"
                            )
                            .map((flashcontent, index) => (
                              <>
                                <div
                                  style={{ gap: "10px" }}
                                  key={flashcontent.id}
                                  className={`d-flex justify-content-between align-items-center flashCard-Content ${draggedItemIndex === index ? "dragging" : ""
                                    }`}
                                >
                                  <RowContainer alignItem="center">
                                    <div
                                      draggable
                                      onDragStart={() => handleDragStart(index)}
                                      onDragOver={(event) =>
                                        handleDragOver(index, event)
                                      }
                                      onDrop={handleDrop}
                                      onDragEnd={handleDragEnd}
                                      onTouchStart={(event) =>
                                        handleTouchStart(index, event)
                                      }
                                      onTouchMove={handleTouchMove}
                                      onTouchEnd={handleTouchEnd}
                                      style={{ cursor: "grab" }}
                                    >
                                      <img
                                        src={dragAndDropIcon}
                                        style={{
                                          cursor: "grab",
                                          backgroundColor: "#D9D9D9",
                                          borderRadius: "5px",
                                          height: "45px",
                                          pointerEvents: "none",
                                        }}
                                        draggable="false"
                                      />
                                    </div>
                                    <div
                                      className="drop_box user"
                                      style={{
                                        width: "100%",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        border:
                                          flashcontent.id ===
                                            latestUpdatesComponentId &&
                                            latestUpdatesComponentId !== null
                                            ? "2px solid green"
                                            : "none",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <Label
                                          fontSize="14px"
                                          color="#000"
                                          fontWeight={400}
                                        >
                                          {flashcontent.name}
                                        </Label>
                                      </div>

                                      <div>
                                        <img
                                          src={ArrowIcon}
                                          style={{
                                            WebkitUserSelect: "none",
                                            userSelect: "none",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </RowContainer>
                                  <RowContainer
                                    justifyContent="end"
                                    width="fit-content"
                                    className="edit-deleteIcon"
                                  >
                                    <div
                                      className="p-0"
                                      style={{
                                        cursor: "pointer",
                                        width: "fit-content",
                                      }}
                                      onClick={() =>
                                        handleEditFlashContent(
                                          flashcontent.id,
                                          flashcontent.name
                                        )
                                      }
                                    >
                                      <img
                                        className="user-scale"
                                        src={editIcon}
                                        style={{
                                          WebkitUserSelect: "none",
                                          userSelect: "none",
                                        }}
                                      />
                                    </div>

                                    <div
                                      className="p-0"
                                      style={{
                                        cursor: "pointer",
                                        width: "fit-content",
                                      }}
                                      onClick={() =>
                                        handleDeleteFlaseCardContent(
                                          flashcontent.id,
                                          flashcontent.name
                                        )
                                      }
                                    >
                                      <img
                                        className="user-scale"
                                        src={deleteIcon}
                                        style={{
                                          WebkitUserSelect: "none",
                                          userSelect: "none",
                                        }}
                                      />
                                    </div>
                                  </RowContainer>
                                </div>
                              </>
                            ))
                        )}
                      </div>
                      <VerticalSpace height={20} />
                      <div className="d-flex justify-content-between align-items-center">
                        <button
                          type="button"
                          className="flashCardContent-button user"
                          style={{
                            color: "#100F15",
                            background: "none",
                            border: "1px solid #100F15",
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            padding: "10px 40px",
                            borderRadius: "10px",
                          }}
                          onClick={handleNewFlaseContent}
                        >
                          Add new
                        </button>

                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ gap: "10px" }}
                        >
                          <RadioButton
                            checked={selectedOption === "bretzel"}
                            onChange={() => handleOptionChange("bretzel")}
                          />
                          <label htmlFor="bretzel">Bretzel</label>
                          <div
                            className="p-0"
                            style={{ cursor: "pointer", width: "fit-content" }}
                            onClick={() => handleEditBretzel()}
                          >
                            <img
                              src={editIcon}
                              className="user-scale"
                              style={{
                                WebkitUserSelect: "none",
                                userSelect: "none",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <VerticalSpace height={150} />
            </div>
            <div
              className="container row d-flex justify-content-center publish-button"
              style={{
                position: "fixed",
                zIndex: 1,
                height: "12%",
                maxWidth: "100%",
                bottom: "0px",
                background:
                  "linear-gradient(178.35deg, rgba(255, 255, 255, 0) 1.4%, rgba(255, 255, 255, 0.69) 26.79%, #FFFFFF 50.22%)",
              }}
            >
              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  zIndex: 1,
                  bottom: "34px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-success d-flex justify-content-center user"
                  style={{
                    backgroundColor: "#FF9E00",
                    color: "#100F15",
                    height: "fit-content",
                    borderRadius: "10px",
                    padding: "10px 20%",
                    width: "400px",
                    fontSize: "14px",
                  }}
                  onClick={() => handlePublishClick()}
                >
                  Publish
                </button>
              </div>
            </div>
          </div>

          {addFlashContnet && (
            <div
              className="modal"
              role="dialog"
              style={{
                display: "block",
                position: "fixed",
                zIndex: 1,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content" style={{ borderRadius: "20px" }}>
                  <div className="modal-body p-3">
                    <h5 style={{ fontWeight: "bold" }}>
                      Add a Flashcard Content Component
                    </h5>
                    <VerticalSpace height={10} />
                    <CustomDropdown
                      items={dropdownItems}
                      onSelect={handleSelect}
                      width="-webkit-fill-available"
                    />
                  </div>
                  <div className="modal-body d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-secondary user"
                      onClick={() => setNewFlashCard(false)}
                      style={{
                        padding: "12px",
                        color: "#100F15",
                        background: "none",
                        border: "1px solid #100F15",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger user"
                      style={{
                        backgroundColor: "#FF9E00",
                        color: "#100F15",
                      }}
                      onClick={handleSaveFlashCard}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {showDeleteDialog && (
        <DeleteConfirmation
          showDeletePopup={true}
          setShowDeletePopup={setShowDeleteDialog}
          message={deleteDialogMessage}
          deleteButtonLabel="Delete"
          onDelete={onConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
      {loading && <DeleteLoader />}
    </div>
  );
};
export default FlashCardContent;
